import { render } from "./FormSelect.vue?vue&type=template&id=23dcd4d6&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=23dcd4d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-23dcd4d6"

export default script